import { render, staticRenderFns } from "./ShopUnit.vue?vue&type=template&id=6f3fead2&scoped=true&"
import script from "./ShopUnit.vue?vue&type=script&lang=js&"
export * from "./ShopUnit.vue?vue&type=script&lang=js&"
import style0 from "./ShopUnit.vue?vue&type=style&index=0&id=6f3fead2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3fead2",
  null
  
)

export default component.exports